module.exports = __webpack_public_path__ + "img/rbc_royal_bank.03c70077.jpg";